import { ViewModelUtil } from 'gw-portals-viewmodel-js';

function extractVMObject(data) {
    // eslint-disable-next-line no-restricted-syntax
    for (const key in data) {
        if (ViewModelUtil.isViewModelNode(data[key])) {
            return data[key];
        }
    }
    return undefined;
}

export default {
    extractVMObject
};
